import { getCompanyLogoWithAuth, resolveCityDataKey, getClientCities } from "../services/companyFileReader";

export const C = {
  lime: "A3E635",
  /** Top/bottom bar lime from Mystery_2025-2026_-_STPS_Sondrio.pptx */
  barLime: "A1E340",
  /** Chart lime used in Mystery_2025-2026_-_STPS_Sondrio.pptx */
  chartLime: "ADE301",
  dark: "353A0A",
  title: "1F2A0A",
  mid: "4C5E12",
  yellow: "FFF260",
  white: "FFFFFF",
  text: "1B1C1C",
  muted: "4A4C44",
  track: "EAEADC",
  border: "E5E5CC",
  grid: "E8E8E8",
  cream: "F9F9F0",
  coverBg: "1A2008",
  divBg: "1F2A0A",
  areaBg: "1A2808",
  catBg: "243E0A",
  cityAccent: "b8d07a",
  purple: "8C74FF",
};

/** Default PPTX typeface (must match STPS reference; falls back only if OS lacks Inter). */
export const PPTX_FONT = "Inter";
/** Slide titles in STPS use Inter ExtraBold / Inter 28pt ExtraBold. */
export const PPTX_TITLE_FONT = "Inter ExtraBold";

export const PREMESSA_BLOCKS = [
  { text: "Il documento illustra l'indagine annuale di Mystery Client, promossa da ASSTRA, che analizza la qualità fornita dalle Aziende di Trasporto Pubblico Locale." },
  { text: "Il contenuto del documento è organizzato nelle seguenti sezioni:" },
  { bold: "Introduzione al Mystery Client:", text: " descrive la metodologia adottata per condurre l'indagine, elaborare e rappresentare i dati raccolti." },
  { bold: "Executive Summary:", text: " presenta in modo sintetico i risultati ottenuti per ciascuna area analizzata." },
  { bold: "Risultati dell'indagine (Elementi Specifici):", text: " dettaglia i risultati relativi agli aspetti specifici e distintivi del servizio, come il monitoraggio di punti vendita, fermate e linee." },
  { bold: "Risultati dell'indagine (Elementi Generali):", text: " approfondisce i risultati legati agli aspetti generali e non direttamente connessi al servizio di una singola linea, come il monitoraggio del call center, del sito web e delle applicazioni." },
];

export const REPORT_CATEGORY_SECTIONS = [
  { key: "punti_vendita", label: "Punti Vendita", divider: "PUNTI VENDITA", tableLabel: "PUNTI VENDITA" },
  { key: "fermate", label: "Fermate", divider: "FERMATE", tableLabel: "FERMATE" },
  { key: "linee_urbane", label: "Linee Urbane", divider: "LINEE", tableLabel: "LINEE" },
  { key: "linee_extraurbane", label: "Linee Extraurbane", divider: "LINEE EXTRAURBANE", tableLabel: "LINEE" },
  { key: "call_center", label: "Call Center", divider: "CALL CENTER", tableLabel: "CALL CENTER" },
  { key: "sito_web", label: "Sito Web", divider: "WEB E APP", tableLabel: "SITO WEB" },
  { key: "app", label: "App", divider: "", tableLabel: "APP" },
];

export const PESATURA_ROWS = [
  { area: "LINEE URBANE", ap: "40%", cat: "OPERATIVITÀ", cp: "27%", param: "PUNTUALITÀ", pp: "60%" },
  { area: "", ap: "", cat: "", cp: "", param: "BIGLIETTO A BORDO", pp: "30%" },
  { area: "", ap: "", cat: "", cp: "", param: "FUNZ. OBLITERATRICE CARTACEA", pp: "3,3%" },
  { area: "", ap: "", cat: "", cp: "", param: "FUNZ. OBLITERATRICE ELETTRONICA", pp: "3,3%" },
  { area: "", ap: "", cat: "", cp: "", param: "STAMPIGLIATURA SUL BIGLIETTO", pp: "3,3%" },
  { area: "", ap: "", cat: "INFORMAZIONI", cp: "18%", param: "CORRETTA ESPOSIZIONE N. LINEA", pp: "38%" },
  { area: "", ap: "", cat: "", cp: "", param: "CORRETTA ESPOSIZIONE DESTINAZIONE", pp: "38%" },
  { area: "", ap: "", cat: "", cp: "", param: "SISTEMA DIFFUSIONE AUDIO", pp: "6%" },
  { area: "", ap: "", cat: "", cp: "", param: "REGOLAMENTO DI VIAGGIO", pp: "6%" },
  { area: "", ap: "", cat: "", cp: "", param: "PMV", pp: "12%" },
  { area: "", ap: "", cat: "COMFORT", cp: "29%", param: "RUMOROSITÀ INTERNA (MOTORE)", pp: "2%" },
  { area: "", ap: "", cat: "", cp: "", param: "RUMOROSITÀ FRENI", pp: "1%" },
  { area: "", ap: "", cat: "", cp: "", param: "VIBRAZIONI INTERNE VETTURA", pp: "4%" },
  { area: "", ap: "", cat: "", cp: "", param: "TEMPERATURA", pp: "28%" },
  { area: "", ap: "", cat: "", cp: "", param: "ODORI", pp: "4%" },
  { area: "", ap: "", cat: "", cp: "", param: "SPAZIO", pp: "38%" },
  { area: "", ap: "", cat: "", cp: "", param: "SEDILI", pp: "1%" },
  { area: "", ap: "", cat: "", cp: "", param: "ARREDO INTERNO", pp: "1%" },
  { area: "", ap: "", cat: "", cp: "", param: "FINESTRINI", pp: "1%" },
  { area: "", ap: "", cat: "", cp: "", param: "PORTE ANTERIORI", pp: "0,3%" },
  { area: "", ap: "", cat: "", cp: "", param: "PORTA CENTRALE", pp: "0,3%" },
  { area: "", ap: "", cat: "", cp: "", param: "PORTA POSTERIORE", pp: "0,3%" },
  { area: "", ap: "", cat: "", cp: "", param: "SEDILI IMBOTTITI", pp: "1%" },
  { area: "", ap: "", cat: "", cp: "", param: "PULIZIA PAVIMENTAZIONE", pp: "6%" },
  { area: "", ap: "", cat: "", cp: "", param: "PULIZIA VETRI", pp: "4%" },
  { area: "", ap: "", cat: "", cp: "", param: "PULIZIA SEDILI", pp: "6%" },
  { area: "", ap: "", cat: "", cp: "", param: "PULIZIA SOSTEGNI E MAN. CORRENTI", pp: "4%" },
  { area: "", ap: "", cat: "STATO DEL MEZZO", cp: "4%", param: "STATO ESTERNO DEL MEZZO", pp: "38%" },
  { area: "", ap: "", cat: "", cp: "", param: "FUMO DI SCARICO", pp: "38%" },
  { area: "", ap: "", cat: "", cp: "", param: "RUMOROSITÀ ESTERNA DEL VEICOLO", pp: "25%" },
  { area: "", ap: "", cat: "SICUREZZA", cp: "9%", param: "VIDEOCAMERE SORVEGLIANZA", pp: "50%" },
  { area: "", ap: "", cat: "", cp: "", param: "UTILIZZO CELLULARI", pp: "19%" },
  { area: "", ap: "", cat: "", cp: "", param: "UTILIZZO AURICOLARI", pp: "6%" },
  { area: "", ap: "", cat: "", cp: "", param: "DISTRAZIONE DALLA GUIDA", pp: "19%" },
  { area: "", ap: "", cat: "", cp: "", param: "ESPOSIZIONE GIORNALI/RIVISTE", pp: "6%" },
  { area: "", ap: "", cat: "PERSONALE", cp: "5%", param: "ACCOGLIENZA", pp: "11%" },
  { area: "", ap: "", cat: "", cp: "", param: "ASPETTO", pp: "6%" },
  { area: "", ap: "", cat: "", cp: "", param: "CARTELLINO RICONOSCIMENTO", pp: "6%" },
  { area: "", ap: "", cat: "", cp: "", param: "DIVISA", pp: "6%" },
  { area: "", ap: "", cat: "", cp: "", param: "ATTEGGIAMENTO", pp: "22%" },
  { area: "", ap: "", cat: "", cp: "", param: "DISPONIBILITÀ", pp: "11%" },
  { area: "", ap: "", cat: "", cp: "", param: "EROGAZIONE SERVIZIO", pp: "22%" },
  { area: "", ap: "", cat: "", cp: "", param: "GUIDA", pp: "11%" },
  { area: "", ap: "", cat: "", cp: "", param: "APERTURA PORTE", pp: "6%" },
  { area: "", ap: "", cat: "ACCESSIBILITÀ", cp: "5%", param: "AREE ATTRACCO CARROZZELLE", pp: "50%" },
  { area: "", ap: "", cat: "", cp: "", param: "POSTI RISERVATI DISABILI/UTENZA DEBOLE", pp: "50%" },
  { area: "", ap: "", cat: "COMUNICAZIONE", cp: "3%", param: "SCRITTE PER PROMOZIONE", pp: "100%" },
  { area: "FERMATE", ap: "25%", cat: "TIPO FERMATA", cp: "4%", param: "PANNELLI PENSILINA", pp: "100%" },
  { area: "", ap: "", cat: "VISIBILITÀ", cp: "12%", param: "VISIBILITÀ", pp: "50%" },
  { area: "", ap: "", cat: "", cp: "", param: "RICONOSCIBILITÀ", pp: "50%" },
  { area: "", ap: "", cat: "STATO", cp: "12%", param: "USURA STRUTTURA", pp: "40%" },
  { area: "", ap: "", cat: "", cp: "", param: "SUPPORTI PER ATTESA (SE PENSILINA)", pp: "60%" },
  { area: "", ap: "", cat: "PULIZIA", cp: "10%", param: "PULIZIA PAVIMENTAZIONE (SE PENSILINA)", pp: "13%" },
  { area: "", ap: "", cat: "", cp: "", param: "PULIZIA SEDILI (SE PENSILINA)", pp: "13%" },
  { area: "", ap: "", cat: "", cp: "", param: "ADESIVI/SCRITTE SU STRUTTURA", pp: "13%" },
  { area: "", ap: "", cat: "", cp: "", param: "VANDALISMI SU AREE INFORMATIVE", pp: "63%" },
  { area: "", ap: "", cat: "INFORMAZIONI", cp: "36%", param: "PMV", pp: "43%" },
  { area: "", ap: "", cat: "", cp: "", param: "TABELLE ORARI", pp: "29%" },
  { area: "", ap: "", cat: "", cp: "", param: "LISTA PUNTI VENDITA", pp: "7%" },
  { area: "", ap: "", cat: "", cp: "", param: "NUMERO TELEFONO AZIENDA", pp: "7%" },
  { area: "", ap: "", cat: "", cp: "", param: "SITO WEB/APP", pp: "7%" },
  { area: "", ap: "", cat: "", cp: "", param: "INFO REPERIMENTO TITOLI", pp: "7%" },
  { area: "", ap: "", cat: "COMUNICAZIONE", cp: "5%", param: "INFO BIGLIETTI/ABBONAMENTI DISPONIBILI", pp: "50%" },
  { area: "", ap: "", cat: "", cp: "", param: "CAMPAGNA COMUNICAZIONE AZIENDALE", pp: "25%" },
  { area: "", ap: "", cat: "", cp: "", param: "CAMPAGNA COMUNICAZIONE DI TERZI", pp: "25%" },
  { area: "", ap: "", cat: "SICUREZZA", cp: "12%", param: "SEGNALETICA ORIZZONTALE", pp: "20%" },
  { area: "", ap: "", cat: "", cp: "", param: "SICUREZZA FERMATA RISPETTO A STRADA", pp: "80%" },
  { area: "", ap: "", cat: "ACCESSIBILITÀ", cp: "10%", param: "LEGGIBILITÀ ORARI", pp: "38%" },
  { area: "", ap: "", cat: "", cp: "", param: "AGEVOLAZIONI SOSTA DISABILI", pp: "31%" },
  { area: "", ap: "", cat: "", cp: "", param: "AGEVOLAZIONI PER NON VEDENTI", pp: "31%" },
  { area: "PUNTI VENDITA", ap: "15%", cat: "ATTESA", cp: "12%", param: "GESTIONE CODA", pp: "20%" },
  { area: "", ap: "", cat: "", cp: "", param: "TEMPO DI ATTESA", pp: "80%" },
  { area: "", ap: "", cat: "VISIBILITÀ", cp: "24%", param: "VISIBILITÀ", pp: "50%" },
  { area: "", ap: "", cat: "", cp: "", param: "RICONOSCIBILITÀ", pp: "50%" },
  { area: "", ap: "", cat: "SPAZIO", cp: "6%", param: "SPAZIO", pp: "100%" },
  { area: "", ap: "", cat: "ODORI", cp: "6%", param: "ODORI", pp: "100%" },
  { area: "", ap: "", cat: "ILLUMINAZIONE", cp: "6%", param: "ILLUMINAZIONE", pp: "100%" },
  { area: "", ap: "", cat: "PULIZIA", cp: "10%", param: "PULIZIA PAVIMENTAZIONE", pp: "25%" },
  { area: "", ap: "", cat: "", cp: "", param: "PULIZIA ATTREZZATURE VARIE", pp: "25%" },
  { area: "", ap: "", cat: "", cp: "", param: "PULIZIA UFFICIO", pp: "25%" },
  { area: "", ap: "", cat: "", cp: "", param: "PULIZIA SUPPORTI PER L'ATTESA", pp: "25%" },
  { area: "", ap: "", cat: "PERSONALE", cp: "36%", param: "ASPETTO", pp: "10%" },
  { area: "", ap: "", cat: "", cp: "", param: "ACCOGLIENZA", pp: "13%" },
  { area: "", ap: "", cat: "", cp: "", param: "ATTEGGIAMENTO", pp: "13%" },
  { area: "", ap: "", cat: "", cp: "", param: "DISPONIBILITÀ", pp: "20%" },
  { area: "", ap: "", cat: "", cp: "", param: "EROGAZIONE SERVIZIO", pp: "27%" },
  { area: "", ap: "", cat: "", cp: "", param: "PROATTIVITÀ", pp: "17%" },
  { area: "CALL CENTER", ap: "5%", cat: "ATTESA", cp: "22%", param: "TEMPO DI ATTESA", pp: "40%" },
  { area: "", ap: "", cat: "", cp: "", param: "TENTATIVI FALLITI PRIMA DI PARLARE CON L'OPERATORE", pp: "60%" },
  { area: "", ap: "", cat: "PERSONALE", cp: "67%", param: "ACCOGLIENZA", pp: "13%" },
  { area: "", ap: "", cat: "", cp: "", param: "ATTEGGIAMENTO", pp: "13%" },
  { area: "", ap: "", cat: "", cp: "", param: "DISPONIBILITÀ", pp: "20%" },
  { area: "", ap: "", cat: "", cp: "", param: "SERVIZIO RESO", pp: "33%" },
  { area: "", ap: "", cat: "", cp: "", param: "PROATTIVITÀ", pp: "20%" },
  { area: "", ap: "", cat: "MESSAGGERIA", cp: "11%", param: "QUALITÀ AUDIO MESSAGGERIA", pp: "20%" },
  { area: "", ap: "", cat: "", cp: "", param: "CHIAREZZA ISTRUZIONI MESSAGGERIA", pp: "80%" },
  { area: "SITO WEB", ap: "7,5%", cat: "CONTENUTI", cp: "45%", param: "INFO LINEE E PERCORSI", pp: "24%" },
  { area: "", ap: "", cat: "", cp: "", param: "INFO TITOLI DI VIAGGIO", pp: "24%" },
  { area: "", ap: "", cat: "", cp: "", param: "MODALITÀ ACQUISTO TITOLI DI VIAGGIO", pp: "20%" },
  { area: "", ap: "", cat: "", cp: "", param: "CANALI CONTATTO AZIENDA", pp: "16%" },
  { area: "", ap: "", cat: "", cp: "", param: "CALCOLO PERCORSO", pp: "16%" },
  { area: "", ap: "", cat: "ESPERIENZA UTENTE", cp: "27%", param: "NAVIGABILITÀ", pp: "24%" },
  { area: "", ap: "", cat: "", cp: "", param: "CHIAREZZA INFO", pp: "32%" },
  { area: "", ap: "", cat: "", cp: "", param: "COMPLETEZZA INFO", pp: "32%" },
  { area: "", ap: "", cat: "", cp: "", param: "RESPONSIVENESS", pp: "12%" },
  { area: "", ap: "", cat: "FUNZIONI", cp: "9%", param: "ELENCO BIGLIETTERIE", pp: "20%" },
  { area: "", ap: "", cat: "", cp: "", param: "INFO IN TEMPO REALE", pp: "70%" },
  { area: "", ap: "", cat: "", cp: "", param: "INFO SU EVENTI TERRITORIO", pp: "10%" },
  { area: "", ap: "", cat: "SERVIZI", cp: "18%", param: "RIMANDO SOCIAL", pp: "16%" },
  { area: "", ap: "", cat: "", cp: "", param: "INDICAZIONE ALL'APP", pp: "42%" },
  { area: "", ap: "", cat: "", cp: "", param: "E-COMMERCE", pp: "42%" },
  { area: "APP", ap: "7,5%", cat: "CONTENUTI", cp: "33%", param: "INFO LINEE E PERCORSI", pp: "50%" },
  { area: "", ap: "", cat: "", cp: "", param: "CALCOLO PERCORSO", pp: "25%" },
  { area: "", ap: "", cat: "", cp: "", param: "INFO REAL TIME", pp: "25%" },
  { area: "", ap: "", cat: "ESPERIENZA UTENTE", cp: "33%", param: "CONTENUTI E CHIAREZZA", pp: "29%" },
  { area: "", ap: "", cat: "", cp: "", param: "ORDINE E CURA", pp: "14%" },
  { area: "", ap: "", cat: "", cp: "", param: "NAVIGABILITÀ", pp: "29%" },
  { area: "", ap: "", cat: "", cp: "", param: "RESPONSIVENESS", pp: "29%" },
  { area: "", ap: "", cat: "FUNZIONALITÀ", cp: "33%", param: "ACQUISTO TITOLI DI VIAGGIO", pp: "80%" },
  { area: "", ap: "", cat: "", cp: "", param: "ELENCO PUNTI VENDITA", pp: "20%" },
];

export const fmt = (n, dec = 1) => n.toFixed(dec).replace(".", ",");
export const fmtP = (n) => `${Math.round(n * 100)}%`;
export const capFirst = (s) => s.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());

function lerpHex(a, b, t) {
  const parse = (h) => [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  const [r1, g1, b1] = parse(a);
  const [r2, g2, b2] = parse(b);
  const f = (x, y) => Math.round(Math.max(0, Math.min(255, x + (y - x) * t)));
  return [f(r1, r2), f(g1, g2), f(b1, b2)].map((v) => v.toString(16).padStart(2, "0")).join("");
}

export function scoreGrad(v) {
  const t = Math.max(0, Math.min(10, v)) / 10;
  return t <= 0.5 ? lerpHex(C.dark, C.yellow, t * 2) : lerpHex(C.yellow, C.lime, (t - 0.5) * 2);
}

export function scoreGradText(v) {
  const t = Math.max(0, Math.min(10, v)) / 10;
  return t <= 0.5 ? lerpHex("353A0A", "8B5E00", t * 2) : lerpHex("8B5E00", "2E6010", (t - 0.5) * 2);
}

export function distCol(label, val) {
  const l = label.toLowerCase();
  if (/perfett|eccell|ottim|ben\s|pulito|assenz|nessun|complet|inequivoc|esaust|funzionant|^si$|presenti\se|rampa\se|percorsi\se/.test(l)) return C.chartLime || C.lime;
  if (/comprom|trascur|scarsi|inadeg|insuff|non\svisib|non\sprot|assenza\sdi|illegg|sconfort|usurato|assenti\so|^no$/.test(l)) return C.dark;
  if (/discret|parzial|suffic|abbastanz|adeg|moderat|solo\s/.test(l)) return C.yellow;
  return scoreGrad(val * 10);
}

export function isNumMap(o) {
  if (typeof o !== "object" || o === null) return false;
  return Object.values(o).every((v) => v === null || typeof v === "number");
}

export function isDist(data) {
  const vals = Object.values(data).filter((v) => v !== null && v !== undefined && isFinite(v));
  if (!vals.length) return false;
  return vals.every((v) => v >= 0 && v <= 1.001);
}

export function isGrouped(o) {
  if (typeof o !== "object" || o === null) return false;
  const e = Object.entries(o);
  if (e.length < 2) return false;
  const ref = new Set(Object.keys(e[0][1] || {}));
  if (!ref.size) return false;
  return e.every(([, v]) =>
    typeof v === "object" && v !== null
    && Object.values(v).every((iv) => iv === null || typeof iv === "number")
    && [...ref].every((k) => k in v)
  );
}

export function getCittaObj(company) {
  return company?.citta || company?.["città"] || {};
}

export function getCityData(company, city) {
  const citta = getCittaObj(company);
  const key = resolveCityDataKey(citta, city);
  return { key, data: citta[key] || {} };
}

export function getIndiceSintetico(company, city) {
  if (!city) return company.indice_sintetico ?? null;
  const { data } = getCityData(company, city);
  if (typeof data.indice_sintetico === "number") return data.indice_sintetico;
  return company.indice_sintetico ?? null;
}

export function getCitiesToPrint(company, selectedCity) {
  const configuredCities = getClientCities(company.azienda);
  const cittaKeys = Object.keys(getCittaObj(company));
  return selectedCity
    ? [selectedCity]
    : (configuredCities.length > 0 ? configuredCities : cittaKeys);
}

export function getReportFileName(company, selectedCity, ext) {
  const yearEnd = company.anno + 1;
  if (selectedCity) {
    return `MC ${company.anno}-${yearEnd} - ${company.azienda} - ${selectedCity} - Esteso.${ext}`;
  }
  return `MC ${company.anno}-${yearEnd} - ${company.azienda} - Esteso.${ext}`;
}

async function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onloadend = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(blob);
  });
}

function detectImageFormat(dataUrl) {
  if (!dataUrl || typeof dataUrl !== "string") return null;
  if (dataUrl.startsWith("data:image/png")) return "png";
  if (dataUrl.startsWith("data:image/jpeg") || dataUrl.startsWith("data:image/jpg")) return "jpeg";
  return null;
}

async function loadImageB64(url) {
  try {
    const token = localStorage.getItem("auth_token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const res = await fetch(url, { headers });
    if (!res.ok) return null;
    const blob = await res.blob();
    if (!blob.type.startsWith("image/")) return null;
    const dataUrl = await blobToDataUrl(blob);
    return detectImageFormat(dataUrl) ? dataUrl : null;
  } catch {
    return null;
  }
}

async function loadBlobUrlAsDataUrl(blobUrl) {
  if (!blobUrl) return null;
  try {
    const res = await fetch(blobUrl);
    const blob = await res.blob();
    if (!blob.type.startsWith("image/")) return null;
    const dataUrl = await blobToDataUrl(blob);
    return detectImageFormat(dataUrl) ? dataUrl : null;
  } catch {
    return null;
  }
}

export async function loadReportAssets(company) {
  const NO_GAMET = ["ATB", "STPS"];
  const showGamet = !NO_GAMET.includes((company.azienda || "").toUpperCase());
  const [logoB64, gametLogoB64] = await Promise.all([
    loadImageB64("/exis.png"),
    showGamet ? loadImageB64("/gamet.png") : Promise.resolve(null),
  ]);

  let companyLogoB64 = null;
  try {
    const blobUrl = await getCompanyLogoWithAuth(company.azienda, company.anno);
    companyLogoB64 = await loadBlobUrlAsDataUrl(blobUrl);
    if (blobUrl) URL.revokeObjectURL(blobUrl);
  } catch {
    // Company logo is optional on the report cover.
  }

  return { logoB64, gametLogoB64, companyLogoB64 };
}
